import React from 'react';
import reframe from 'nike-re-framejs';
import Immutable from 'immutable';
import { getLocale } from '@/common/oldMobile';

function BannersSelectionHeader({ betId }) {
    const derefSub = reframe.useReframe();
    const betBanner = derefSub(['sub:betbanners/by-bet-number', betId]) || Immutable.Map();
    const market = betBanner.getIn(['market', getLocale()]);
    return <div className="BannersSelectionHeader">{market}</div>;
}

export default BannersSelectionHeader;
